import React from 'react';

const Highlights = () => (
  <div className="container mx-auto text-center px-4 sm:px-6 lg:px-8 bg-white py-10 rounded-lg shadow-lg">
    <h2 className="text-3xl sm:text-4xl font-bold text-blue-600 mb-6">Course Highlights</h2>
    <ul className="mt-6 space-y-4 text-left max-w-3xl mx-auto">
      <li className="flex items-start">
        <span className="text-green-500 font-bold mr-2">✔</span>
        Live 1-on-1 mentoring sessions with industry experts
      </li>
      <li className="flex items-start">
        <span className="text-green-500 font-bold mr-2">✔</span>
        Real-world project development with code reviews
      </li>
      <li className="flex items-start">
        <span className="text-green-500 font-bold mr-2">✔</span>
        Industry-standard tools and best practices
      </li>
      <li className="flex items-start">
        <span className="text-green-500 font-bold mr-2">✔</span>
        Portfolio building with 5+ projects
      </li>
    </ul>
  </div>
);

export default Highlights;
